import gql from 'graphql-tag';

export const pageInfoFieldsFragment  = gql`
  fragment AdminPageInfoFields on PageInfo {
    totalCount
    pageSize
    hasPreviousPage
    hasNextPage
    startCursor
    endCursor
  }
`;